import Dialog from "./dialog";

Dialog.install = function (Vue) {
  const DialogComponent = Vue.extend(Dialog);
  let instance = new DialogComponent().$mount();

  document.body.appendChild(instance.$el);

  Vue.prototype.$dialog = (option) => {
    instance.dialogTitle = option.title;
    instance.dialogContent = option.content;
    if (option.leftBtn) {
      instance.leftBtn = {
        ...instance.leftBtn,
        ...option.leftBtn,
      };
    }
    if (option.rightBtn) {
      instance.rightBtn = {
        ...instance.rightBtn,
        ...option.rightBtn,
      };
    }
    if (option.leftClick) instance.leftCollback = option.leftClick;
    if (option.rightClick) instance.rightCollback = option.rightClick;
    instance.dialogState = true;
  };
};

export default Dialog;
